import React, {Fragment, useContext, FunctionComponent, MouseEvent} from 'react';
import './EntryEdit.less';
import {ModifierTrigger} from '../modifier-trigger/ModifierTrigger';
import {QuantityPicker} from 'compositions/quantity-picker/QuantityPicker.tsx';
import {ListSplitter} from 'elements/list-splitter/ListSplitter.tsx';
import {ModifierValue} from 'elements/modifier-value/ModifierValue';
import {getSelectedModifiersFromGroup} from 'helpers/modifier.helper';
import {TranslationsContext} from 'contexts/translations-context';
import {getSafeTranslation} from 'helpers/localization.helper.ts';
import {ModifierGroup, MenuEntryModifierSelections, ModifierGroupId} from 'helpers/modifier.helper.types.ts';

interface EntryEditProps {
	quantity: number,
	modifierGroups: Array<ModifierGroup>,
	modifierSelections: MenuEntryModifierSelections,
	onModifierGroupClick: (e: MouseEvent, clickedModifierGroupId: ModifierGroupId) => void,
	onQuantityDecClick: (e: MouseEvent) => void,
	onQuantityIncClick: (e: MouseEvent) => void,
	isSmall?: boolean,
}

export const EntryEdit: FunctionComponent<EntryEditProps> = (
	{
		quantity,
		modifierGroups = [],
		modifierSelections = {},
		onModifierGroupClick,
		onQuantityDecClick,
		onQuantityIncClick,
		isSmall,
	}
) => {

	const translations = useContext(TranslationsContext);

	return (
		<ul className="entry-edit">
			<li key="quantity-picker" className="entry-edit__item">
				<ModifierTrigger
					name={getSafeTranslation('EntryEdit.amountLabel', translations).replace('{quantity}', quantity.toString())}
					control={(!modifierGroups.find(modifierGroup => modifierGroup.allowToChangeQuantity) || isSmall) &&
					<QuantityPicker onDecClick={onQuantityDecClick} onIncClick={onQuantityIncClick}/>}
					isSmall={isSmall}
				/>
			</li>
			{modifierGroups.length > 0 &&
			modifierGroups.map(modifierGroup => {
				const selectedModifierNames = getSelectedModifiersFromGroup(modifierGroup, modifierSelections[modifierGroup.modifierGroupId])
					.map(modifier => {
						const modifierSelection = modifierSelections[modifierGroup.modifierGroupId]
							.find(modifierSelection => modifierSelection.modifierId === modifier.modifierId);

						return modifierGroup.allowToChangeQuantity && modifierSelection.quantity > 1
							? `${modifierSelection.quantity} x ${modifier.name}`
							: modifier.name;
					});

				return (
					<Fragment key={modifierGroup.modifierGroupId}>
						<ListSplitter/>
						<li
							onClick={e => onModifierGroupClick(e, modifierGroup.modifierGroupId)}
							className="entry-edit__item"
						>
							<ModifierTrigger
								name={modifierGroup.name}
								control={<ModifierValue isSmall={isSmall}
								>
									{
										selectedModifierNames.length > 0
											? selectedModifierNames.map(name => <span key={name}>{name}</span>)
											: getSafeTranslation('EntryEdit.modifierNotSelectedValue', translations)

									}
								</ModifierValue>}
								isSmall={isSmall}
							/>
						</li>
					</Fragment>
				);
			})}
		</ul>
	);
};
